import Vue from 'vue'

const state = {
  currentEvent: {},
  pricing: null,
  entry_count: null
}

const mutations = {
  setCurrentEvent: (state, payload) => {
    if (payload.event) {
      state.currentEvent = payload.event
    }
  },
  setCurrentEntries: (state, payload) => {
    state.entry_count = payload.entries
  },
  setEntryQuestionReservations: (state, payload) => {
    let eq = state.currentEvent.entry_questions.filter(eq => eq.entry_question_id === payload.entry_question_id)[0]
    Vue.set(eq.details, 'number_reserved', payload.reserved)
  },
  setEventEntryQuestions: (state, payload) => {
    // state.currentEvent.entry_questions = payload
    Vue.set(state.currentEvent, 'entry_questions', payload)
  }
}

const actions = {
  // Event Actions
  loadCurrentEvent: ({commit, state, getters, rootState, dispatch}, payload) => {
    if (rootState.user) {
      return rootState.apiInstance.get(`/callFunction/showHome?event_id=${payload.event_slug}&user_id=${rootState.user ? getters.getUserID : ''}`)
        .then(response => {
          if (rootState.user) {
            commit('setCurrentEvent', {event: response.data.data.event})
            commit('setCurrentEntries', {entries: response.data.data.total_entries})
            if (response.data.data.entryGroup) {
              // Edited on 8/25 to fix entry grouping
              // var entryGroup = response.data.data.entryGroup
              var entryGroup = Vue.prototype.fixEntryGrouping(response.data.data.entryGroup)
              dispatch('setCurrentEntryGroup', entryGroup)
            } else {
              dispatch('setCurrentEntryGroup', {})
            }
          } else {
            commit('setCurrentEvent', {event: response.data.data})
            dispatch('setCurrentEntryGroup', {})
          }
        })
    } else {
      return rootState.apiInstance.get(`/callFunction/showHome?event_id=${payload.event_slug}`)
        .then(response => {
          if (rootState.user) {
            commit('setCurrentEvent', {event: response.data.data.event})
            if (response.data.data.entryGroup) {
              // Edited on 8/25 to fix entry grouping
              // var entryGroup = response.data.data.entryGroup
              var entryGroup = Vue.prototype.fixEntryGrouping(response.data.data.entryGroup)

              for (var i = 0; i < (state.currentEvent.customEntryQuestions.length - entryGroup.customAnswers.length); i++) {
                entryGroup.customAnswers.push({})
              }
              entryGroup.entries = response.data.data.entries
              entryGroup.payments = response.data.data.payments
              entryGroup.calculatedCost = response.data.data.calculated_cost
              dispatch('setCurrentEntryGroup', entryGroup)
            } else {
              dispatch('setCurrentEntryGroup', {})
            }
          } else {
            commit('setCurrentEvent', {event: response.data.data})
            dispatch('setCurrentEntryGroup', {})
          }
        })
    }
  },
  getEventPricing: ({commit, dispatch, state, rootState}, payload) => {
    rootState.apiInstance.get('/data/event_pricing')
      .then(response => {
        commit('setEventPricing', response.data)
      })
  },
  checkEventEntryQuestionAvailability ({commit, state, rootState}, payload) {
    return rootState.apiInstance.get(`/checkEntryQuestionAvailability?event_id=${state.currentEvent.event_id}&entry_question_id=${payload.entry_question_id}`)
      .then(response => {
        commit('setEntryQuestionReservations', {reserved: response.data.reserved, entry_question_id: payload.entry_question_id})
        return response.data.reserved
      })
  },
  getEntryQuestions: ({commit, state, rootState}, payload) => {
    return rootState.apiInstance.get(`/getUpdatedEntryQuestions?event_id=${state.currentEvent.event_id}`)
      .then(response => {
        commit('setEventEntryQuestions', response.data)
        return response.data
      })
  }
}

export default {
  namespaced: false,
  state,
  actions,
  mutations
}
